<template>
  <el-menu
    ref="menus"
    :router="true"
    class="el-menu-vertical ft16"
    text-color="#303133"
    active-text-color="#2F96FF"
    :default-active="defaultActive"
  >
    <template v-for="itemi in menuList">
      <el-submenu v-if="itemi.children.length" :key="itemi.menu_name" :index="itemi.menu_name">
        <template slot="title">
          <i v-if="itemi.menu_icon" :class="itemi.menu_icon" class="menu-icon"></i>
          <span>{{ itemi.menu_name }}</span>
        </template>
        <template v-for="itemj in itemi.children">
          <el-menu-item
            v-if="routeList.includes(itemj.menu_path)"
            :key="itemj.menu_path"
            :index="itemj.menu_path"
            :route="{ name: itemj.menu_path }"
            class="menu-item"
          >
            <span class="pl40">{{ itemj.menu_name }}</span>
          </el-menu-item>
          <el-menu-item v-else :key="itemj.menu_path" :index="itemj.menu_path" class="menu-item">
            <i v-if="itemi.menu_icon" :class="itemi.menu_icon" class="menu-icon"></i>
            <a class="menu-link" :href="itemj.menu_path">
              {{ itemj.menu_name }}
            </a>
            <!-- <span class="pl40">{{ itemj.menu_name }}</span> -->
          </el-menu-item>
        </template>
        <!-- <el-menu-item
          v-for="itemj in itemi.children"
          :key="itemj.menu_path"
          :index="itemj.menu_path"
          :route="{ name: itemj.menu_path }"
          class="menu-item"
        >
          <span class="pl40">{{ itemj.menu_name }}</span>
        </el-menu-item> -->
      </el-submenu>
      <template v-else>
        <el-menu-item
          v-if="routeList.includes(itemi.menu_path)"
          :key="itemi.menu_name"
          :index="itemi.menu_path"
          :route="{ name: itemi.menu_path }"
        >
          <i v-if="itemi.menu_icon" :class="itemi.menu_icon" class="menu-icon"></i>
          <span slot="title">{{ itemi.menu_name }}</span>
        </el-menu-item>
        <el-menu-item v-else :key="itemi.menu_path" :index="itemi.menu_path">
          <i v-if="itemi.menu_icon" :class="itemi.menu_icon" class="menu-icon"></i>
          <a :href="formatMenuPath(itemi.menu_path)" class="menu-link" target="_blank">
            {{ itemi.menu_name }}
          </a>
          <!-- <span class="pl40">{{ itemj.menu_name }}</span> -->
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>
<script>
import { mapGetters } from 'vuex';
import { MENU_ROUTE } from '@/utils/constant';
import { replaceParams } from '@/libs/utils/util';
import { routes } from '@/router';
import login from '@/utils/login';

export default {
  name: 'SideMenu',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      menuList: 'getMenuList',
    }),
    defaultActive() {
      const routerName = this.$route.name;
      let active = routerName;
      Object.keys(MENU_ROUTE).forEach((item) => {
        if (item === routerName || (MENU_ROUTE[item] && MENU_ROUTE[item].includes(routerName))) {
          active = item;
        }
      });
      return active;
    },
    routeList() {
      const list = [];
      routes.forEach((route) => {
        if (route.name) {
          list.push(route.name);
        }
      });
      return list;
    },
    // formatMenuPath(path) {
    //   console.log('formatMenuPath', path);
    //   return path;
    //   // return `${path}?name=123`;
    // },
  },
  created() {
    console.log(123);
  },
  mounted() {},
  methods: {
    formatMenuPath(path) {
      console.log('formatMenuPath', path);
      if (/^http/.test(path)) {
        const token = login.getToken();
        return replaceParams({ token }, path);
        // console.log(replaceParams({ token }, path));
      }
      return path;
    },
  },
};
</script>
<style scoped>
@import '../common/icomoon/style.css';
</style>
<style lang="scss" scoped>
.el-menu-vertical {
  margin-top: 24px;
  background-color: #ffffff;
  border: none;
  .ft16 {
    font-size: 16px;
  }
  .menu-item {
    font-weight: 500;
    height: 48px;
    line-height: 48px;
  }
  ::v-deep .el-submenu__title {
    height: 48px;
    line-height: 48px;
  }
  .menu-icon {
    margin-right: 24px;
    font-size: 24px;
    margin-left: 4px;
  }
  .pl40 {
    padding-left: 40px;
  }
  .pl52 {
    padding-left: 52px;
  }
  .menu-link {
    text-decoration: none;
    color: rgb(48, 49, 51);
    display: inline-block;
    width: 90%;
    height: 100%;
  }
}
</style>
